var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNervous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 128,
    cy: 128,
    r: 118.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "63.5,120.2 86.1,108 63.5,95.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "192.5,120.2 169.9,108 192.5,95.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.5,167.1c-1.9,6.1-7.6,10.3-14.3,10.3c-6.9,0-12.7-4.6-14.4-11l0,0c-2.1-5.8-7.6-9.9-14.1-9.9 c-6.7,0-12.5,4.5-14.3,10.6c-1.9,6.1-7.6,10.3-14.3,10.3c-6.9,0-12.7-4.6-14.4-11c-2.1-5.7-7.6-9.9-14-9.9 c-6.7,0-12.5,4.5-14.3,10.6c-1.9,6.1-7.6,10.3-14.3,10.3c-6.9,0-12.7-4.6-14.4-11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNervous);
export default __webpack_public_path__ + "static/media/Nervous.f3e0f504d967b29482d3936f9484caa1.svg";
export { ForwardRef as ReactComponent };